export default "__VITE_ASSET__BKTOqe1x__"